import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  totalPages: number;
  totalItems: number;
  onChange: (page: number) => void;
}

/** Paginação simples (anterior/próxima) no rodapé das listas. */
export const Pagination: React.FC<PaginationProps> = ({ page, totalPages, totalItems, onChange }) => (
  <div className="flex items-center justify-between px-4 py-3 border-t border-slate-200 bg-white text-sm text-slate-600">
    <span>
      {totalItems.toLocaleString('pt-BR')} {totalItems === 1 ? 'item' : 'itens'}
    </span>
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="p-1.5 rounded-lg border border-slate-200 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="Página anterior"
      >
        <ChevronLeft size={16} />
      </button>
      <span>
        Página {Math.min(page, Math.max(totalPages, 1))} de {Math.max(totalPages, 1)}
      </span>
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="p-1.5 rounded-lg border border-slate-200 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="Próxima página"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  </div>
);
